import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { wbCore } from "@whalar/blocks";

// Convert theme objects to arrays of values that tailwind-merge expects
const colors = Object.entries(wbCore.color).flatMap(([group, values]) =>
  typeof values === "object"
    ? Object.keys(values).map((key) => `${group}-${key}`)
    : []
);

const spacing = Object.keys(wbCore.spacing);

// Configure tailwind-merge with our design system's custom values
const twMerge = extendTailwindMerge({
  override: {
    theme: {
      colors,
      spacing,
      borderRadius: spacing, // borderRadius uses same scale as spacing
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type AnyFunction = (...args: any[]) => any;
export const noop: AnyFunction = () => {};
